import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import AccordionApplication from "../../../Accordion/AccordionApplication";
import uni from "../../../../images/fb0bb5cd017b15aa49ee7a86a2e0c972.png";

import Title from "../../../Title/Title";
import Add from "../../../Buttons/Add";
import { useParams } from "react-router-dom";
import { useDelete, useFetch, usePOST } from "../../../../ApiS";
import Loader from "../../../Loader";
import Table, { TableOperation } from "../../../Table";
import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { Edit } from "lucide-react";
import { IoIosClose } from "react-icons/io";
import Input from "../../../Inputs/Input";
import { CgAdd } from "react-icons/cg";
import { TbTrash } from "react-icons/tb";
import { BiEditAlt } from "react-icons/bi";
import PopUpDelete from "../../../PopUps/PopUpDelete (1)";
import { usePopUpsStore } from "../../../../store/PopUpStore";
import Selected from "../../../Inputs/Selected";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { RiEditBoxFill } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import { AxiosError } from "axios";

interface academic_positions {
  id: number | string;
  name?: string;
  start_year?: string;
  end_year?: string;
}

interface InfoTeacher {
  title?: string[];
  thesis_title?: string[];
  university_name?: string[];
  collage_name?: string[];
  specialization?: string[];
  degree?: string[];
  rate?: string[];
  graduation_year?: string[];
  name?: string[];
  start_year?: string[];
  end_year?: string[];
  text?: string[];
  type?: string[];
}

export default function InfoTeacher() {
  const { id } = useParams();
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();
  const [View, setView] = useState<string>();

  const [isOpen, setisOpen] = useState(false);
  const [selected, setSelected] = useState<number | null>(null);
  const [idInfos, setidInfos] = useState<number | string | undefined>();
  //  -------------------------
  const [isOpenAchievement, setisOpenAchievement] = useState(false);
  const [selectedAchievement, setSelectedAchievement] = useState<number | null>(
    null
  );
  const [idAchievement, setidAchievement] = useState<
    number | string | undefined
  >();
  const [errors, setErrors] = useState<InfoTeacher>({});

  const onError = (
    error: AxiosError<{ errors: InfoTeacher; message: string }>
  ) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  // --------------------------

  const [isOpenAcademic, setisOpenAcademic] = useState(false);
  const [selectedAcademic, setSelectedAcademic] = useState<number | null>(null);
  const [idAcademic, setidAcademic] = useState<number>();

  const { data, isLoading } = useFetch(
    `admin/doctors/${id}`,
    `admin/doctors/${id}`
  );

  const { data: dataInfos, isLoading: isLoadingInfos } = useFetch(
    `admin/doctors/${id}/academic-infos/${idInfos}`,
    `admin/doctors/${id}/academic-infos/${idInfos}`,
    idInfos ? true : false
  );

  const { deleteItem } = useDelete(
    () => {},
    () => {}
  );

  const openEditPopup = (idInfo?: number) => {
    setSelected(idInfo!);
    setidInfos(idInfo);
    setisOpen(true);
  };

  const closePopup = () => {
    setisOpen(false);
    setSelected(null);
  };

  const { handleSubmit, handleChangeInput, mutation } = usePOST(
    {},
    () => {
      closePopup();
      window.location.reload();
    },
    (error) => {
      onError(error);
    }
  );
  // -------------------------------------------------------------------------

  const { data: dataAchievement, isLoading: isLoadingAchievement } = useFetch(
    `admin/doctors/${id}/achievements/${idAchievement}`,
    `admin/doctors/${id}/achievements/${idAchievement}`,
    idAchievement ? true : false
  );

  const openEditPopupAchievement = (idInfo?: number) => {
    setSelectedAchievement(idInfo!);
    setidAchievement(idInfo);
    setisOpenAchievement(true);
  };

  const closePopupAchievement = () => {
    setisOpenAchievement(false);
    setSelectedAchievement(null);
  };

  const {
    handleSubmit: submitAchievement,
    handleChangeInput: handleChangeInputAchievement,
    mutation: mutationAchievement,
    handleChangeSelect,
  } = usePOST(
    {},
    () => {
      closePopupAchievement();
      window.location.reload();
    },
    (error) => {
      onError(error);
    }
  );

  // ---------------------

  const { data: dataAcademic, isLoading: isLoadingAcademic } = useFetch(
    `admin/doctors/${id}/academic-positions/${idAcademic}`,
    `admin/doctors/${id}/academic-positions/${idAcademic}`,
    idAcademic ? true : false
  );

  const openEditPopupAcademic = (idInfo?: number) => {
    setSelectedAcademic(idInfo!);
    setidAcademic(idInfo);
    setisOpenAcademic(true);
  };

  const closePopupAcademic = () => {
    setisOpenAcademic(false);
    setSelectedAcademic(null);
  };

  const {
    handleSubmit: submitAcademic,
    handleChangeInput: handleChangeInputAcademic,
    mutation: mutationAcademic,
  } = usePOST(
    {},
    () => {
      closePopupAcademic();
      window.location.reload();
    },
    (error) => {
      onError(error);
    }
  );

  // {data?.data?.academic_positions?.map((e: any) => {
  //   setidAcademic(e.id);
  // })}

  const operations: TableOperation[] = [
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: false,
      onClick: (id: string | number) => {
        if (typeof id === "number") {
          setidAcademic(id);
          openEditPopupAcademic(id);
        }
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
        setView("position");
      },
    },
  ];

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <ToastContainer position="bottom-left" style={{ zIndex: "99999999" }} />
      <Row>
        <Col lg={4}>
          <Title title="معلومات الدكتور" />
        </Col>
      </Row>

      <Row justify="around">
        <Col lg={10} md={10} sm={12} className=" !px-4 !py-4">
          {/* <Row>
            <Col lg={2} className="flex justify-center">
              <img src={uni} className="rounded-full w-[100px] h-[100px]" />
            </Col>
            <Col lg={2} className="flex items-center">
              <h1 className="text-2xl font-bold max-lg:mx-auto">اسم الدكتور</h1>
            </Col>
          </Row> */}
          <Row justify={"center"} className="!mt-5">
            <Col lg={10} md={10} sm={12} className="mx-5 border-2 rounded-lg p-4 ">
              <div className="mx-5 text-lg">
                <div className="pb-4 text-Secondary font-bold text-center">
                  المعلومات الشخصية
                </div>
                <div className="pb-2">
                  المرتبة العلمية :<span> {data?.data?.academic_rank}</span>
                </div>
                <div className="pb-2">
                  {" "}
                  الايميل :<span>{data?.data?.email}</span>
                </div>
                <div className="pb-2">
                  {" "}
                  الهاتف :<span> {data?.data?.phone} </span>
                </div>
                <div className="pb-2">
                  {" "}
                  الفاكس :<span>{data?.data?.fax}</span>
                </div>
                <div className="pb-2 ">
                  {" "}
                  الموبايل :<span>{data?.data?.mobile}</span>
                </div>
              </div>
            </Col>

            <Col lg={10} md={10} sm={12} className="mx-5 border-2 rounded-lg p-4">
              <div className="font-bold text-lg pb-4 text-Secondary text-center">
                المعلومات الاكاديمية
              </div>

              <Col className="">
                <div
                  className="flex cursor-pointer"
                  onClick={() => openEditPopup()}
                >
                  <p className="text-green-700 mt-1 font-bold">
                    {" "}
                    اضف معلومات اكاديمية{" "}
                  </p>
                  <CgAdd
                    size={30}
                    className="text-green-700 cursor-pointer flex  "
                  />
                </div>
              </Col>

              {data?.data?.infos?.map((e: any) => (
                <Row>
                  <Col lg={9} md={9} sm={9}>
                    <AccordionApplication
                      className="my-3 w-full"
                      name={e?.title}
                      doctora={true}
                      // title={data?.data?.infos[0]?.title}
                      name_university={e?.university_name}
                      name_collage={e?.collage_name}
                      Specialization={e?.specialization}
                      rate={e?.rate}
                      degree={e?.degree}
                      Graduation={e?.graduation_year}
                    />
                  </Col>
                  <Col lg={1} md={1} sm={1} className="">
                    <TbTrash
                      size={25}
                      className="text-red-600 cursor-pointer mt-5"
                      onClick={(id: any) => {
                        setPopUpDelete([id, true]);
                        setView("infos");
                      }}
                    />
                  </Col>
                  <Col lg={1} md={1} sm={1} className="">
                    <BiEditAlt
                      size={25}
                      className="text-blue-600 cursor-pointer mt-5"
                      onClick={() => openEditPopup(e.id)}
                    />
                  </Col>
                  {View === "infos" && (
                    <PopUpDelete
                      text="هل أنت متأكد من حذف هذه المعلومة؟ "
                      onClickDelete={() =>
                        deleteItem(`admin/doctors/${id}/academic-infos/${e.id}`)
                      }
                    />
                  )}
                </Row>
              ))}
            </Col>

            <Col lg={10} md={10} sm={12} className="mx-5 border-2 rounded-lg p-4">
              <div className="pb-4 text-Secondary text-lg font-bold text-center">
                المناصب العلمية :
              </div>
              <Row justify="center">
                <Col className="">
                  <div
                    className="flex cursor-pointer"
                    onClick={() => openEditPopupAcademic()}
                  >
                    <p className="text-green-700 mt-1 font-bold">
                      {" "}
                      اضف منصب علمي{" "}
                    </p>
                    <CgAdd
                      size={30}
                      className="text-green-700 cursor-pointer flex  "
                    />
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} className=" !py-4">
                  <Table<academic_positions>
                    tableHeads={[
                      " اسم المنصب ",
                      " تاريخ البداية ",
                      " تاريخ النهاية ",
                      "العمليات",
                    ]}
                    tableBody={data?.data?.academic_positions}
                    keys={["name", "start_year", "end_year"]}
                    operations={operations}
                    className="!min-w-[10px]"
                  />

                  {View === "position" && (
                    <PopUpDelete
                      text="هل أنت متأكد من حذف هذا المنصب؟"
                      onClickDelete={() =>
                        deleteItem(
                          `admin/doctors/${id}/academic-positions/${popUpDelete[0]}`
                        )
                      }
                    />
                  )}
                </Col>
              </Row>
            </Col>
            <Col lg={10} md={10} sm={12} className="mx-5 border-2 rounded-lg p-4 ">
              <>
                <div className="pb-4 text-Secondary text-lg font-bold text-center">
                  الأنجازات :
                </div>
                <Col className="">
                  <div
                    className="flex cursor-pointer"
                    onClick={() => openEditPopupAchievement()}
                  >
                    <p className="text-green-700 mt-1 font-bold">
                      {" "}
                      اضف أنجازات{" "}
                    </p>
                    <CgAdd
                      size={30}
                      className="text-green-700 cursor-pointer flex  "
                    />
                  </div>
                </Col>
                {data?.data?.achievements?.map((e: any) => (
                  <Row>
                    <Col lg={9} md={9} sm={9}>
                      <AccordionApplication
                        className="my-2"
                        text={e.text}
                        name={e.title}
                        type={e.type}
                        book={true}
                      />
                    </Col>
                    <Col lg={1} md={1} sm={1} className="">
                      <TbTrash
                        size={25}
                        className="text-red-600 cursor-pointer mt-5"
                        onClick={(id: any) => {
                          setPopUpDelete([id, true]);
                          setView("Achievement");
                        }}
                      />
                    </Col>
                    <Col lg={1} md={1} sm={1} className="">
                      <BiEditAlt
                        size={25}
                        className="text-blue-600 cursor-pointer mt-5"
                        onClick={() => openEditPopupAchievement(e.id)}
                      />
                    </Col>
                    {View === "Achievement" && (
                      <PopUpDelete
                        text="هل أنت متأكد من حذف هذا الانجاز؟  "
                        onClickDelete={() =>
                          deleteItem(`admin/doctors/${id}/achievements/${e.id}`)
                        }
                      />
                    )}
                  </Row>
                ))}
              </>
            </Col>
          </Row>
        </Col>
      </Row>

      {/*  PopUp  Infos   */}

      <div>
        {isOpen && (
          <div
            className="flex fixed justify-center items-center h-full w-full top-0 left-0 z-99999"
            // onClick={closePopup}
          >
            <div className="fixed w-full h-full bg-black/30 z-99999" />
            <div
              className="bg-white flex flex-col rounded-xl p-5 z-99999 w-1/2 h-2/3 overflow-y-auto max-md:w-[90%]"
              onClick={(e) => e.stopPropagation()}
            >
              {isLoadingInfos ? (
                <Loader />
              ) : (
                <>
                  <div
                    className="flex p-1 bg-gray-100 w-fit rounded-full cursor-pointer"
                    onClick={closePopup}
                  >
                    <IoIosClose size={25} />
                  </div>
                  <div className="flex flex-col gap-5">
                    <div
                    // key={e.id}
                    >
                      <Input
                        name="title"
                        type="text"
                        placeholder={"العنوان "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.title : ""
                        }
                        title="العنوان"
                        onChange={handleChangeInput}
                      />
                      {errors?.title &&
                        errors?.title.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}

                      <Input
                        name="thesis_title"
                        type="text"
                        placeholder={" عنوان الرسالة "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.thesis_title : ""
                        }
                        title="عنوان الرسالة"
                        onChange={handleChangeInput}
                      />
                        {errors?.thesis_title &&
                        errors?.thesis_title.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="university_name"
                        type="text"
                        placeholder={" اسم الجامعة "}
                        defaultValue={
                          idInfos != null
                            ? dataInfos?.data?.university_name
                            : ""
                        }
                        title=" اسم الجامعة "
                        onChange={handleChangeInput}
                      />
                        {errors?.university_name &&
                        errors?.university_name.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="collage_name"
                        type="text"
                        placeholder={" اسم الكلية "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.collage_name : ""
                        }
                        title=" اسم الكلية "
                        onChange={handleChangeInput}
                      />
                        {errors?.collage_name &&
                        errors?.collage_name.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="specialization"
                        type="text"
                        placeholder={" الاختصاص  "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.specialization : ""
                        }
                        title=" الاختصاص "
                        onChange={handleChangeInput}
                      />
                        {errors?.specialization &&
                        errors?.specialization.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="degree"
                        type="text"
                        placeholder={" الدرجة  "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.degree : ""
                        }
                        title=" الدرجة "
                        onChange={handleChangeInput}
                      />
                        {errors?.degree &&
                        errors?.degree.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="rate"
                        type="number"
                        placeholder={" معدل  "}
                        defaultValue={
                          idInfos != null ? dataInfos?.data?.rate : ""
                        }
                        title=" معدل "
                        onChange={handleChangeInput}
                      />
                        {errors?.rate &&
                        errors?.rate.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        name="graduation_year"
                        type="date"
                        placeholder={" سنة التخرج  "}
                        defaultValue={
                          idInfos != null
                            ? dataInfos?.data?.graduation_year
                            : ""
                        }
                        title=" سنة التخرج "
                        onChange={handleChangeInput}
                      />
                        {errors?.graduation_year &&
                        errors?.graduation_year.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </div>
                  </div>
                  {mutation.isLoading && <Loader />}
                  <div className="flex flex-col gap-2 mt-6">
                    <button
                      className="text-lg bg-green-600 hover:bg-green-500 text-white font-semibold rounded-lg w-full p-2"
                      onClick={() =>
                        handleSubmit(
                          idInfos
                            ? `admin/doctors/${id}/academic-infos/${idInfos}?_method=PUT`
                            : `admin/doctors/${id}/academic-infos`
                        )
                      }
                    >
                      حفظ التعديلات
                    </button>
                    <button
                      className="text-lg bg-white border border-primary text-primary font-semibold rounded-lg w-full p-2"
                      onClick={closePopup}
                    >
                      إلغاء
                    </button>
                  </div>{" "}
                </>
              )}
            </div>
          </div>
          // PopUp Delete Option
        )}
      </div>

      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}

      {/*  PopUp  achevment   */}

      <div>
        {isOpenAchievement && (
          <div
            className="flex fixed justify-center items-center h-full w-full top-0 left-0 z-[100000]"
            // onClick={closePopupAchievement}
          >
            <div className="fixed w-full h-full bg-black/30 z-[100001]" />
            <div
              className="bg-white flex flex-col rounded-xl p-5 z-[100002] w-1/2 h-2/3 overflow-y-auto max-md:w-[90%]"
              onClick={(e) => e.stopPropagation()}
            >
              {isLoadingAchievement ? (
                <Loader />
              ) : (
                <>
                  <div
                    className="flex p-1 bg-gray-100 w-fit rounded-full cursor-pointer"
                    onClick={closePopupAchievement}
                  >
                    <IoIosClose size={25} />
                  </div>
                  <div className="flex flex-col gap-5">
                    <div
                    // key={e.id}
                    >
                      <Input
                        type="text"
                        name="title"
                        placeholder=" العنوان "
                        title=" العنوان "
                        onChange={handleChangeInputAchievement}
                        defaultValue={
                          idAchievement != null
                            ? dataAchievement?.data?.title
                            : ""
                        }
                      />
                        {errors?.title &&
                        errors?.title.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        type="text"
                        name="text"
                        placeholder=" الاسم "
                        title=" الاسم "
                        onChange={handleChangeInputAchievement}
                        defaultValue={
                          idAchievement != null
                            ? dataAchievement?.data?.text
                            : ""
                        }
                      />
                        {errors?.text &&
                        errors?.text.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Selected
                        name="type"
                        defaultValue={
                          idAchievement != null
                            ? dataAchievement?.data?.type
                            : ""
                        }
                        title="النوع"
                        onChange={(e) =>
                          handleChangeSelect({
                            value: e.currentTarget.value,
                            label: e.currentTarget.name,
                          })
                        }
                      >
                        <option value="scientific_research">
                          {" "}
                          البحث العلمي{" "}
                        </option>
                        <option value="books_and_scientific_publications">
                          {" "}
                          الكتب والمنشورات العلمية{" "}
                        </option>
                        <option value="conferences"> المؤتمرات </option>
                        <option value="teaching_experience">
                          {" "}
                          خبرة التدريس{" "}
                        </option>
                      </Selected>
                      {errors?.type &&
                        errors?.type.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </div>
                  </div>
                  {mutationAchievement.isLoading && <Loader />}
                  <div className="flex flex-col gap-2 mt-6">
                    <button
                      className="text-lg bg-green-600 hover:bg-green-500 text-white font-semibold rounded-lg w-full p-2"
                      onClick={() =>
                        submitAchievement(
                          idAchievement
                            ? `admin/doctors/${id}/achievements/${idAchievement}?_method=PUT`
                            : `admin/doctors/${id}/achievements`
                        )
                      }
                    >
                      حفظ التعديلات
                    </button>
                    <button
                      className="text-lg bg-white border border-primary text-primary font-semibold rounded-lg w-full p-2"
                      onClick={closePopupAchievement}
                    >
                      إلغاء
                    </button>
                  </div>{" "}
                </>
              )}
            </div>
          </div>
          // PopUp Delete Option
        )}
      </div>

      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}
      {/* ----------------------------------------------------------------------------------- */}

      {/*  PopUp  achevment   */}

      <div>
        {isOpenAcademic && (
          <div
            className="flex fixed justify-center items-center h-full w-full top-0 left-0 z-[100000]"
            onClick={closePopupAcademic}
          >
            <div className="fixed w-full h-full bg-black/30 z-[100001]" />
            <div
              className="bg-white flex flex-col rounded-xl p-5 z-[100002] w-1/2 h-2/3 overflow-y-auto max-md:w-[90%]"
              onClick={(e) => e.stopPropagation()}
            >
              {isLoadingAcademic ? (
                <Loader />
              ) : (
                <>
                  <div
                    className="flex p-1 bg-gray-100 w-fit rounded-full cursor-pointer"
                    onClick={closePopupAcademic}
                  >
                    <IoIosClose size={25} />
                  </div>
                  <div className="flex flex-col gap-5">
                    <div
                    // key={e.id}
                    >
                      <Input
                        type="text"
                        name="name"
                        placeholder=" اسم المنصب "
                        title=" اسم المنصب "
                        onChange={handleChangeInputAcademic}
                        defaultValue={
                          idAcademic ? dataAcademic?.data?.name : ""
                        }
                      />
                        {errors?.name &&
                        errors?.name.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                      <Input
                        type="date"
                        name="start_year"
                        placeholder="  تاريخ البداية "
                        title="  تاريخ البداية "
                        defaultValue={
                          idAcademic ? dataAcademic?.data?.start_year : ""
                        }
                        onChange={handleChangeInputAcademic}
                      />
                        {errors?.start_year &&
                        errors?.start_year.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}

                      <Input
                        type="date"
                        name="end_year"
                        placeholder="  تاريخ النهاية "
                        title="  تاريخ النهاية "
                        defaultValue={
                          idAcademic ? dataAcademic?.data?.end_year : ""
                        }
                        onChange={handleChangeInputAcademic}
                      />
                        {errors?.end_year &&
                        errors?.end_year.map((error: any, index: any) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </div>
                  </div>
                  {mutationAcademic.isLoading && <Loader />}
                  <div className="flex flex-col gap-2 mt-6">
                    <button
                      className="text-lg bg-green-600 hover:bg-green-500 text-white font-semibold rounded-lg w-full p-2"
                      onClick={() =>
                        submitAcademic(
                          idAcademic
                            ? `admin/doctors/${id}/academic-positions/${idAcademic}?_method=PUT`
                            : `admin/doctors/${id}/academic-positions`
                        )
                      }
                    >
                      حفظ التعديلات
                    </button>
                    <button
                      className="text-lg bg-white border border-primary text-primary font-semibold rounded-lg w-full p-2"
                      onClick={closePopupAcademic}
                    >
                      إلغاء
                    </button>
                  </div>{" "}
                </>
              )}
            </div>
          </div>
          // PopUp Delete Option
        )}
      </div>
    </>
  );
}
